(function () {
  // Events, die je nach Dawn-Version feuern können
  const VARIANT_EVENTS = ['variant:change', 'variant-change'];

  function switchToVariantMedia(detail) {
    const variant = detail && (detail.variant || detail.selectedVariant || detail.currentVariant);
    if (!variant || !variant.featured_media || !variant.featured_media.id) return;

    // Wir suchen die nächste Media-Gallery in derselben Produkt-Section
    // und clicken das passende Thumbnail/Slide
    const section = document.querySelector(`[data-section-id="${detail.sectionId}"]`) || document;
    const sectionId =
      detail.sectionId ||
      (section.querySelector('[id^="MediaGallery-"]')?.id || '').replace('MediaGallery-', '') ||
      (section.querySelector('[id^="GalleryViewer-"]')?.id || '').replace('GalleryViewer-', '');

    if (!sectionId) return;

    const mediaKey = `${sectionId}-${variant.featured_media.id}`;

    // 1) Versuche, über Thumbnail zu navigieren (bevorzugt, da Slider-Logik intakt bleibt)
    const thumbBtn =
      document.querySelector(`#GalleryThumbnails-${sectionId} [data-target="${mediaKey}"] button.thumbnail`) ||
      document.querySelector(`[data-target="${mediaKey}"] button.thumbnail`);

    if (thumbBtn) {
      thumbBtn.click();
      return;
    }

    // 2) Fallback: direkt die große Kachel anklicken
    const slide = document.querySelector(`[data-media-id="${mediaKey}"]`);
    if (slide) {
      slide.click();
      // Zusätzlich Klassen pflegen, falls Slider nicht reagiert
      const viewer = document.querySelector(`#GalleryViewer-${sectionId} .product__media-list`);
      if (viewer) {
        viewer.querySelectorAll('.slider__slide.is-active').forEach(el => el.classList.remove('is-active'));
        slide.classList.add('is-active');
      }
    }
  }

  // Globale Listener
  VARIANT_EVENTS.forEach(evt =>
    document.addEventListener(evt, e => switchToVariantMedia(e.detail || {}), { passive: true })
  );

  // Fallback für Themes, die nur auf change vom Form feuern
  document.addEventListener('change', e => {
    // Sucht Daten am nächsten Produkt-Formular
    const productForm = e.target?.form?.closest('product-form, form[action*="/cart/add"]');
    if (!productForm) return;

    // Viele Dawn-Versionen hängen den Variant-Datensatz am Form-Element
    const detail =
      productForm?.dataset?.variant
        ? { variant: JSON.parse(productForm.dataset.variant) }
        : (e.detail || {});

    // Versuche, eine Section-ID zu leiten
    const sectionEl = productForm.closest('[data-section-id]');
    if (sectionEl) detail.sectionId = sectionEl.getAttribute('data-section-id');

    switchToVariantMedia(detail);
  });

  // Optional: Beim ersten Render, falls direkt mit vorgewählter Variante geladen wird,
  // aber wir initial das Featured-Image zeigen: Nichts tun -> gewünschtes Verhalten.
})();
